




import { Component, Prop, Vue } from 'vue-property-decorator';
declare let $: any;
const win: any = window;
@Component({
})
export default class BackWash extends Vue {
    @Prop({ default: true }) private hasHeight!: boolean;

    @Prop({ default: '' }) private secondTitle!: string;

    // private code = win.F10Utils.getUrlParams('code');

    // private codeName = win.F10Utils.getUrlParams('code_name');

    private isInApp = win.F10Utils.getBroker();
    private timeInterval: any = ''
    private created() {
        if (!this.isInApp) {
            this.init()
        }   
    }

    private init() {
        const prt = location.protocol;
        const isFromiFinD = window.location.search.indexOf('fromifindapp')>-1? true : false;
        const url = isFromiFinD? "//s.thsi.cn/js/basic/stock/newMobileJs/backWash_ifind.js": "//s.thsi.cn/js/m/business/backWash/backWash_v2.1.1.js"
        
        this.loadJs(prt + url, function(){
            win.backWash.init({
                noNav: false,
                url: window.location.href
            });
        });
        this.loadCss(prt + "//i.thsi.cn/m/share/styles/backWash.css");
        //微信授权 二次分享使用
        this.loadJs(prt + "//upass.10jqka.com.cn/asset/wechatlogin/js/checkwechat.js", '');
        const wxShareUrl = prt+"//s.thsi.cn/js/m/v2.10/common/wxShare.js";
        if (win.jQuery) {
            const $firstItem = $(".conceptn-item").eq(0);
            let title = "";
            if(this.secondTitle) {
                title = this.secondTitle
            }
            let desc = win.F10Utils.getBroker() === 'ifind'? "同花顺 iFinD": "同花顺";
            try{
                desc = $firstItem.find(".conceptn-item-title").eq(0).text()+" "+$firstItem.find(".conceptn-item-explain-simple").eq(0).text().trim();
            }catch(e){
                console.log(e)
            }
            this.loadJs(wxShareUrl,function(){
                const imgUrl = 'http://s.thsi.cn/ifind/images/thsifindlogo.gif'
                const config = isFromiFinD ? {title:title,desc:desc,imgUrl:imgUrl}:{title:title,desc:desc};
                win.wxShare && win.wxShare.init(config);
            });
        } else {
            this.timeInterval = setInterval(()=>{
                if (win.jQuery) {
                    clearInterval(this.timeInterval);
                    this.timeInterval = '';
                    const $firstItem = $(".conceptn-item").eq(0);
                    let title = "";
                    if(this.secondTitle) {
                        title = this.secondTitle
                    }
                    let desc = win.F10Utils.getBroker() === 'ifind'? "同花顺 iFinD": "同花顺";
                    try{
                        desc = $firstItem.find(".conceptn-item-title").eq(0).text()+" "+$firstItem.find(".conceptn-item-explain-simple").eq(0).text().trim();
                    }catch(e){
                        console.log(e)
                    }
                    this.loadJs(wxShareUrl,function(){
                        const imgUrl = 'http://s.thsi.cn/ifind/images/thsifindlogo.gif'
                        const config = isFromiFinD ? {title:title,desc:desc,imgUrl:imgUrl}:{title:title,desc:desc};
                        win.wxShare && win.wxShare.init(config);
                    });

                }
            }, 1000);
        }

    }
// 动态加载js
    private loadJs(url: any, callback: any) {
        const script: any = document.createElement("script");
        script.type = "text/javascript";
        const callbackIsFunc = typeof(callback) == "function";
        if (script.readyState) {
            script.onreadystatechange = function() {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callbackIsFunc && callback();
                }
            }
        } else {
            script.onload = function() {
                callbackIsFunc && callback();
            }
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    //动态加载css
    loadCss(url: any) {
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }
}
